import RewardStructureStripeSubscription from
  '@/datatypes/promocode/reward-structure/stripe-subscription';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default class SubscriptionRewardStructure {
  public items: RewardStructureStripeSubscription[];

  constructor(options) {
    this.items = options.items.map(
      (data) => new RewardStructureStripeSubscription(camelcaseKeysDeep(data)),
    );
  }
}
